import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArticleCardSkeleton = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 288,
	height: 56,
	fill: "none",
	viewBox: "0 0 288 56",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#F5F5F5",
		d: "M0 5h48v47H0zm69-5h165v13H69zm0 22h219v13H69zm0 21h88v13H69z"
	})
});
export default SvgArticleCardSkeleton;
